import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Button, Form, Input, message } from "antd";
import { AuthenticationService } from "../../../../../../services";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../../../store/reducers/authentication";

const Style = styled.div`
  .form-footer {
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-top: 28px;
  }
`;

export default function ResetPassword({ config = {} }) {
  const { t } = useTranslation();
  const [MainForm] = Form.useForm();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authentication);

  const _resetForm = () =>
    MainForm.resetFields(['confirmPassword', 'password', 'currentPassword']);

  const _submit = () => {
    MainForm.validateFields()
      .then(async (v) => {
        try {
          config?.setLoading(true);
          const { data } = await AuthenticationService.changePassword({
            oldPassword: v.currentPassword,
            newPassword: v.password,
            plainPassword: v.confirmPassword,
          });
          dispatch(actions.updateUser({
            ...user,
            passwordChangedAt: data.passwordChangedAt,
          }));
          config?.setLoading(false);
          message.success(t('Password successfully updated.'));
          MainForm.resetFields();
        } catch (err) {
          console.log(err);
          config?.setLoading(false);
          message.error(t(err.message || 'Error changing password'));
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <Style>
      <Form form={MainForm} layout="vertical">
        <Form.Item
          label={t("Current password")}
          name="currentPassword"
          rules={[
            {
              required: true,
              message: t("errors::password should not be empty"),
            },
          ]}
        >
          <Input.Password
            size="large"
            placeholder={t("••••••••")}
            type="password"
            className="email" />
        </Form.Item>
        <Form.Item
          label={t("New password")}
          name="password"
          rules={[
            {
              required: true,
              message: t("errors::password should not be empty"),
            },
          ]}
        >
          <Input.Password
            size="large"
            placeholder={t("••••••••")}
            type="password"
            className="email" />
        </Form.Item>
        <Form.Item
          label={t("Confirm new password")}
          name="confirmPassword"
          dependencies={['password']}
          rules={[
            {
              required: true,
              message: t("errors::password should not be empty"),
            },
            ({ getFieldValue }) => ({
              validator(rule, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(t('errors::passwordNotMatch'));
              },
            }),
          ]}>
          <Input.Password
            size="large"
            placeholder={t("••••••••")}
            type="password"
            className="email" />
        </Form.Item>
        <div className="form-footer">
          <Button onClick={_resetForm}>
            {t('Cancel')}
          </Button>
          <Button type="primary" onClick={_submit} disabled={config?.loading} loading={config?.loading}>
            {t('Update')}
          </Button>
        </div>
      </Form>
    </Style>
  )
}
